import { useContext, useEffect, useState } from 'react';
import '../css/user/edituser.css'; // Assuming you use the same CSS for styling the modal
import { Dimcontext } from '../../context/pagecontext';
import { Button, Form, FormControl, FormGroup, FormLabel, Row, Col } from 'react-bootstrap';
import { MdClose, MdVisibility, MdDomain, MdLocationOn, MdAccessTime, MdSettingsInputAntenna } from 'react-icons/md';
import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';
import { Datacontext } from '../../context/dataContext';

export const ViewBranch = ({ set_view, id }) => {
    const { setDim } = useContext(Dimcontext);
    
    // Assuming Datacontext provides branches
    const { branches = [] } = useContext(Datacontext); 
    
    const [branchData, setBranchData] = useState({
        name: '',
        lattitude: '',
        longitude: '',
        radius: '',
        geofence: '',
        shift: ''
    });

    const handleviewclose = () => {
        set_view(false);
        setDim(false);
    };

    useEffect(() => {
        // 1. Find the branch object
        const selectedBranch = branches.find(item => item.id === id);

        // 2. Only update if the branch was actually found
        if (selectedBranch) {
            setBranchData({
                name: selectedBranch.name || '',
                lattitude: selectedBranch.lattitude?.toString() || '',
                longitude: selectedBranch.longitude?.toString() || '',
                radius: selectedBranch.radius?.toString() || '',
                geofence: selectedBranch.geofence || 'disable',
                shift: selectedBranch.shift?.toString() || '1'
            });
        }
    }, [id, branches]); 

    return (
        <div className="edituser-card shadow-lg">
            <div className="modal-header-custom">
                <div className="header-title">
                    <MdVisibility className="me-2" />
                    <span>View Branch Details</span>
                </div>
                <button onClick={handleviewclose} className="btn-close-custom">
                    <MdClose />
                </button>
            </div>

            <SimpleBar style={{ width: '100%', height: 'calc(80vh - 70px)' }} noScrollX>
                <Form className="p-4">
                    
                    {/* Section: Basic Details */}
                    <div className="form-section">
                        <h6 className="section-title">
                            <MdDomain className="me-2"/>Basic Information
                        </h6>
                        <Row className="g-3">
                            <Col md={12}>
                                <FormGroup>
                                    <FormLabel>Branch Name</FormLabel>
                                    <FormControl 
                                        readOnly 
                                        value={branchData.name.toUpperCase()} 
                                        className="input-readonly fw-bold text-primary" 
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                    </div>

                    {/* Section: Location & Geofencing */}
                    <div className="form-section mt-4">
                        <h6 className="section-title">
                            <MdLocationOn className="me-2"/>Location Settings
                        </h6>
                        <Row className="g-3">
                            <Col md={6}>
                                <FormGroup>
                                    <FormLabel>Lattitude</FormLabel>
                                    <FormControl readOnly value={branchData.lattitude} className="input-readonly text-muted" />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <FormLabel>Longitude</FormLabel>
                                    <FormControl readOnly value={branchData.longitude} className="input-readonly text-muted" />
                                </FormGroup>
                            </Col>
                            <Col md={12}>
                                <FormGroup>
                                    <FormLabel>Radius (in meters)</FormLabel>
                                    <FormControl readOnly value={branchData.radius} className="input-readonly text-muted" />
                                </FormGroup>
                            </Col>

                            <Col md={12}>
                                <div className="doc-collect-box border p-3 rounded bg-light mt-2">
                                    <FormLabel className="me-4 fw-bold mb-0 text-muted"><MdSettingsInputAntenna className="me-1"/> Geofencing Status</FormLabel>
                                    <Form.Check 
                                        inline 
                                        disabled 
                                        label="Enabled" 
                                        type="radio" 
                                        checked={branchData.geofence === 'enable'} 
                                    />
                                    <Form.Check 
                                        inline 
                                        disabled 
                                        label="Disabled" 
                                        type="radio" 
                                        checked={branchData.geofence === 'disable'} 
                                    />
                                </div>
                            </Col>
                            <Col md={12}>
                                <FormGroup className="doc-collect-box mt-2 bg-light border p-3 rounded">
                                    <FormLabel className="me-4 fw-bold mb-0 text-muted"><MdAccessTime className="me-1"/> Shift Schedule</FormLabel>
                                    <Form.Check 
                                        inline disabled label="Shift 1" type="radio" 
                                        checked={branchData.shift === '1'} 
                                    />
                                    <Form.Check 
                                        inline disabled label="Shift 2" type="radio" 
                                        checked={branchData.shift === '2'} 
                                    />
                                    <Form.Check 
                                        inline disabled label="Shift 3" type="radio" 
                                        checked={branchData.shift === '3'} 
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                    </div>

                    <div className="footer-actions sticky-bottom bg-white p-3 border-top mt-4">
                        <Button variant="outline-secondary" className="px-5 w-100 shadow-sm" onClick={handleviewclose}>
                            Close Details
                        </Button>
                    </div>
                </Form>
            </SimpleBar>
        </div>
    );
};